import { RootState } from "../../../redux-store";
import { createSelector } from "@reduxjs/toolkit";

export const selectFinanceConfiguration = (state: RootState) => {
  return state.data.finance.configuration?.financeSystem || null;
};

export const selectIsFinanceIntegrationTripletex = createSelector(
  selectFinanceConfiguration,
  (config) => config === "Tripletex"
);

export const selectIsFinanceIntegrationPowerOffice = createSelector(
  selectFinanceConfiguration,
  (config) => config === "PowerOffice"
);

// The finance system's product name as its users know it, for user-facing
// text. Product names are not translated.
export const selectFinanceSystemName = createSelector(
  selectFinanceConfiguration,
  (config) => (config === "E-CONOMIC" ? "e-conomic" : config)
);
